import Loader from "components/loader/Loader";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
  Badge,
  Progress,
} from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import PayrollModel from "models/payroll.modal";
import AttendanceModel from "models/Attendance.modal";
import Salarytutors from "models/salary.modal";
import moment from "moment";

const View = () => {
  const navigation = useNavigate();
  const parms = useParams();
  const location = useLocation();
  const [modal, setModal] = useState(false);
  const [datalist, setDatalist] = useState();

  const toggle = () => setModal(!modal);

  const navigate = useNavigate();
  const [addsLoadig, setAddsLoadig] = useState();
  const [progress, setprogress] = useState();
  console.log("rrrr", datalist);
  useEffect(() => {
    const paidAmount = datalist?.data?.price_tutor || 0;
    const totalAmount = datalist?.data?.total_amount || 1; // Avoid division by 0
    const progress = totalAmount !== 0 ? (paidAmount / totalAmount) * 100 : 0;

    setprogress(progress);
  }, [datalist]);
  const Datalist = async () => {
    PayrollModel.Getlist(parms.id)
      .then((responce) => {
        setDatalist(responce);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [attendenceData, setAttendenceData] = useState();
  let status = datalist?.data?.status.toLowerCase();
  const GetAttendence = async () => {
    AttendanceModel.GetAllAttendanceList(
      parms.id,
      datalist?.data?.lastClassCycle?.id,
      status
    )
      .then((responce) => {
        setAttendenceData(responce);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [salarydatalist, setSalarydataList] = useState();
  const SalaryData = async () => {
    Salarytutors.getlist(parms.id)
      .then((responce) => {
        setSalarydataList(responce);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    Datalist();
    SalaryData();
  }, [location]);

  useEffect(() => {
    GetAttendence();
  }, [datalist]);

  const remainingSessions =
    (datalist?.data?.number_of_session || 0) -
    (datalist?.data?.sessionCompleted || 0);
  const totalSessions = datalist?.data?.number_of_session || 1; // Default to 1 to avoid division by zero
  const completedSessions = datalist?.data?.sessionCompleted || 0;

  const progressPercentage = Math.min(
    Math.max((completedSessions / totalSessions) * 100, 0),
    100
  );
  const [modal1, setModal1] = useState(false);
  const toggle1 = () => {
    setModal1(!modal1);
  };
  const [cycledata, setCycledata] = useState();
  const GetAllCycle = async () => {
    AttendanceModel.getcycle(parms?.id)
      .then((responce) => {
        setCycledata(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    if (parms?.mid) {
      GetAllCycle();
    }
  }, [location]);
  const [totalFees, setTotalFees] = useState(0);
  useEffect(() => {
    if (attendenceData?.data?.data) {
      const total = attendenceData.data.data.reduce((sum, item) => {
        return sum + (parseFloat(item.fees_for_turor) || 0); // Ensures valid numbers
      }, 0);
      setTotalFees(total);
    }
  }, [attendenceData]);
  console.log("payroll view", datalist);
  const consumedPercents = Math.round(
    (totalFees / datalist?.data?.monthly_payscale) * 100
  );
  return (
    <>
      {datalist?.data ? (
        <Container className="pt-7">
          <Container>
            <Row className="mt-4">
              <Col>
                <h2>Tutor's Payroll Management</h2>
                <div style={{ display: "flex" }}>
                  <div className="mb-3 ">
                    <strong>Tutors Name:</strong>{" "}
                    {datalist?.data?.tutorData?.first_name}{" "}
                    {datalist?.data?.tutorData?.last_name}
                  </div>
                  <div className="mb-3 ml-3">
                    <strong>Class Status:</strong>{" "}
                    <span className="badge badge-success">
                      {datalist?.data?.class_status}
                    </span>
                  </div>
                </div>
                <div className="mb-3 d-flex">
                 {/* <Button color="light">Student Select Drop Down</Button>*/}
                  <div>
                    <Label
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        marginTop: "16px",
                      }}
                    >
                      Cycle
                    </Label>
                    <select
                      className="px-4 ml-2 mt-2 rounded py-1"
                      defaultValue={parms?.mid}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        if (parms?.id && selectedValue) {
                          navigation(
                            `/admin/creditmapping/creditmapping-view/${parms.id}/${selectedValue}`
                          );
                        }
                      }}
                    >
                      {cycledata?.map((item, index) => {
                        return <option value={item?.id}>{index + 1}</option>;
                      })}
                    </select>
                  </div>

                  {/*<Button color="light" className="ml-2">
                    Edit Remark
                  </Button>*/}
                </div>
                <Row>
                  <div className="col mt-3">
                    <Card className="shadow">
                      <CardHeader className="border-0 d-flex justify-content-between ">
                        <h3 className="mb-0">Students List</h3>
                      </CardHeader>

                      <Table
                        className="align-items-center table-flush"
                        responsive
                      >
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">Student Name</th>
                            <th scope="col">School/College/University Name</th>

                            <th scope="col">Gender</th>
                            <th scope="col">Date of Birth</th>

                            <th scope="col">Preferred Time Duration</th>
                            <th scope="col">Term</th>

                            {/* <th scope="col"> Enquiry For</th> */}
                            <th scope="col"> Loaction City</th>
                          </tr>
                        </thead>

                        {true && (
                          <tbody>
                            {datalist?.data?.studentData?.map((item, index) => {
                              return (
                                <tr style={{ cursor: "pointer" }} key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item?.name || "-"}</td>
                                  <td>{item?.school_name || "-"}</td>

                                  <td>{item?.gender}</td>
                                  <td>{item?.dob}</td>

                                  <td>{item?.preferrd_time}</td>
                                  <td>{item?.term}</td>

                                  <td>{item?.location}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        )}
                      </Table>
                    </Card>
                  </div>
                </Row>
                <Card>
                  <CardBody>
                    <CardTitle tag="h5">Package</CardTitle>
                    <Row>
                      <Col md="6">
                        <p>
                          <strong>Fee Charge per hour:</strong> ₹{" "}
                          {datalist?.data?.hourly_fee}
                        </p>
                        <p className="bg-dark text-white p-2">
                          <strong>Tutor Salary per hour:</strong> ₹{" "}
                          {datalist?.data?.hourly_payscale}
                        </p>
                      </Col>
                      <Col md="6">
                        <p>
                          <strong>Sessions a week:</strong>{" "}
                          {datalist?.data?.number_of_session / 4} sessions |{" "}
                          {datalist?.data?.hours / 4} Hours
                        </p>
                        <p>
                          <strong>Sessions in a month:</strong>{" "}
                          {datalist?.data?.session_per_month} sessions /{" "}
                          {datalist?.data?.hours} Hours
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <p>
                          <strong>Monthly Charge:</strong>{" "}
                          {datalist?.data?.monthly_fee}
                        </p>
                      </Col>
                      <Col md="6">
                        <p>
                          <strong>Pay:</strong>{" "}
                          {datalist?.data?.monthly_payscale}
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <div className="col">
                <Card className="shadow">
                  <CardHeader className="border-0 d-flex justify-content-between ">
                    <h3 className="mb-0">Attendance Overview</h3>

                    <Col md={6}>
                      <Button
                        style={{
                          backgroundColor: "#080278",
                          color: "white",
                          border: "none",
                        }}
                        color="primary"
                        type="submit"
                        tag={Link}
                        onClick={toggle1}
                      >
                        Details View
                      </Button>
                      <Button
                        style={{
                          float: "right",
                          backgroundColor: "#080278",
                          color: "white",
                          border: "none",
                        }}
                        color="primary"
                        type="submit"
                        to="/admin/creditmapping/creditmapping-view/tutors-replacement"
                        tag={Link}
                      >
                        Replace Tutors
                      </Button>
                    </Col>
                  </CardHeader>

                  <CardBody>
                    <div>
                      <Row>
                        <Col md={5}>
                          <FormGroup>
                            <Label for="exampleEmail">
                              {" "}
                              No. Of Sessions Completed{" "}
                              {datalist?.data?.sessionCompleted}/
                              {datalist?.data?.number_of_session}
                            </Label>
                            <Progress
                              className="my-2"
                              value={progressPercentage}
                              style={{ height: "25px" }}
                            >
                              {progressPercentage.toFixed(0)}%
                            </Progress>
                          </FormGroup>
                        </Col>
                        <Col md={2}></Col>

                        <Col md={5}>
                          <FormGroup>
                            <Label for="exampleEmail">
                              {" "}
                              Remaining Sessions
                            </Label>
                            <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                              {remainingSessions}
                            </p>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col
                          md={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p
                            style={{
                              border: "2px solid black",
                              padding: "20px",
                            }}
                          >
                            <spna>
                              <i
                                class="fa-solid fa-triangle-exclamation"
                                style={{ color: "red", fontSize: "20px" }}
                              ></i>
                            </spna>
                            <span
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                marginLeft: "20px",
                              }}
                            >
                              Your Class Cycle will Expire in Approx{" "}
                              {28 -
                                moment().diff(
                                  moment(datalist?.data?.start_date),
                                  "days"
                                ) +
                                1}{" "}
                              Days
                            </span>
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </Row>
          </Container>
          <Container className="mt-5">
            <Row>
              <Col md="6" className="text-center">
                <div style={{ width: 200, height: 200, margin: "0 auto" }}>
                  <CircularProgressbar
                    value={consumedPercents}
                    text={`${consumedPercents}%`}
                    styles={buildStyles({
                      pathColor: "#1e90ff",
                      textColor: "#000",
                      trailColor: "#d6d6d6",
                      backgroundColor: "#3e98c7",
                    })}
                  />
                </div>
                <div className="mt-3">
                  <strong>
                    ₹ {totalFees} /{" "}
                    {datalist?.data?.monthly_payscale}
                  </strong>
                </div>
              </Col>
              <Col md="6">
                <h3>Credit Counter</h3>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Attendance</th>
                      <th>Per class fee</th>
                      <th>Tutor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attendenceData?.data?.data?.map((item, index) => {
                      console.log("data credit", item);
                      return (
                        <tr key={index}>
                          <td>{item.date}</td>
                          <td>{item.class_type}</td>
                          <td>{item.fees_for_turor} ₹</td>
                          <td>
                            {item?.tutorData?.first_name}{" "}
                            {item?.tutorData?.last_name}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-between">
                  <div>₹ {datalist?.data?.monthly_payscale}</div>
                  <div>
                    ₹{" "}
                    {totalFees}
                  </div>
                  <div>₹ {datalist?.data?.monthly_payscale - totalFees}</div>
                </div>
              </Col>
            </Row>
            <Row className="mt-5">
              <Col md="6">
                <div>Balance</div>
                <div>Unallocated Sessions: {remainingSessions}</div>
                <div>Usually pays by: {datalist?.lastPayment?.pay_mode}</div>
                <Button color="primary" className="mt-2" onClick={() => navigate("/admin/draftTutorsSalary")}>
                  View Full History
                </Button>
              </Col>
              <Col md="6">
                <div>
                  Available Balance: ₹
                  {datalist?.data?.monthly_payscale - totalFees}
                </div>
                <div>
                  Number of Payments:{" "}
                  {datalist?.invoiceData?.number_of_payments}
                </div>
                <div>
                  Total Paid: ₹{" "}
                  {datalist?.invoiceData?.total_paid == null
                    ? 0
                    : datalist?.invoiceData?.total_paid}
                </div>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row className="mt-4">
              <Col>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label for="bankDetails">Bank Details</Label>
                    </FormGroup>
                    <Row>
                      <Col md="4">
                        <p>
                          <strong>Usually pays:</strong> UPI
                        </p>
                      </Col>
                      <Col md="4">
                        <p>
                          <strong>Salary Owed:</strong> ₹{" "}
                          {datalist?.invoiceData?.total_paid == null
                            ? 0
                            : datalist?.invoiceData?.total_paid}
                          /-
                        </p>
                      </Col>
                      <Col md="4">
                        <p>
                          <strong>Number of Payments:</strong>{" "}
                          {datalist?.invoiceData?.number_of_payments}
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <h3 className="mt-4">Total Payment Orders</h3>
                <Card>
                  <CardBody>
                    <Row>
                      <Col md="6">
                        <p>
                          <strong>Total paid:</strong>{" "}
                          {datalist?.invoiceData?.total_paid == null
                            ? 0
                            : datalist?.invoiceData?.total_paid}{" "}
                          ₹
                        </p>
                      </Col>
                      <Col md="6">
                        <p>
                          <strong>Total unpaid:</strong>{" "}
                          {(datalist?.data?.total_amount ?? 0) -
                            (datalist?.invoiceData?.total_paid ?? 0) ===
                          0
                            ? 0
                            : datalist?.data?.total_amount -
                              (datalist?.invoiceData?.total_paid ?? 0)}{" "}
                          ₹
                        </p>
                      </Col>
                    </Row>

                    <Table bordered>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Student Name</th>
                          <th>Bill No.</th>
                          <th>Attendance Time Period</th>
                          <th>Status</th>
                          <th>Debit</th>
                          <th>Left</th>
                        </tr>
                      </thead>
                      <tbody>
                        {salarydatalist?.data?.data?.map((item, index) => {
                          console.log("testes", item);
                          return (
                            <tr>
                              <td>{item?.cycle_completion_date}</td>
                              <td>{item?.studentData?.[0]?.name}</td>
                              <td></td>
                              <td>
                                from - {item?.attendanceData?.from?.date} To{" "}
                                {item?.attendanceData?.to?.date}{" "}
                              </td>
                              <td>
                                <Badge color="warning">{item.status}</Badge>
                              </td>
                              <td>{item?.total_amount}</td>
                              <td></td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>
              <h4>Mark To Paid</h4>
            </ModalHeader>
            <ModalBody>
              <Form>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="exampleEmail">Request Amount</Label>
                      <Input
                        id="forType"
                        type="text"
                        disabled
                        // onChange={handleName}
                        // value={name}
                        placeholder="Enter Request Amount"
                      ></Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="exampleEmail"> Date</Label>
                      <Input
                        id="forType"
                        type="date"
                        // onChange={handleName}
                        // value={name}
                        placeholder="Enter UPI id "
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="exampleEmail">Mode</Label>
                      <Input id="forType" name="forType" type="select">
                        <option value="driver">Select Mode </option>
                        <option value="tutor">UPI </option>
                        <option value="student"> Bank Transfer</option>
                        <option value="student">Cash Payment</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="exampleEmail">Payment Amount</Label>
                      <Input
                        id="forType"
                        type="text"
                        // onChange={handleName}
                        // value={name}
                        placeholder="Enter Payment Amount"
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="exampleEmail">ScreenShot</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        id="forType"
                        type="file"
                        // onChange={handleName}
                        // value={name}
                        placeholder="Enter UPI id "
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="exampleEmail">Transaction id</Label>
                      <Input
                        id="forType"
                        type="text"
                        // onChange={handleName}
                        // value={name}
                        placeholder="Enter Transaction id "
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                  }}
                >
                  Save
                </Button>
              </div>
            </ModalBody>
          </Modal>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>
              <h4>Mark To Paid</h4>
            </ModalHeader>
          </Modal>
          <Modal isOpen={modal1} toggle={toggle1} className="modal-lg">
            <ModalHeader toggle={toggle1}>
              <h3>Attendence view</h3>
              <h4>
                Tutor Name -{" "}
                {attendenceData?.data?.data?.[0]?.tutorData?.first_name}{" "}
                {attendenceData?.data?.data?.[0]?.tutorData?.last_name}
              </h4>
              <h4>Total Session - {attendenceData?.data?.totalSession}</h4>
            </ModalHeader>
            <ModalBody>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Attendance date</th>
                    <th scope="col">class_type</th>

                    <th scope="col">classlink</th>
                    <th scope="col">classmode</th>

                    <th scope="col">currentClassMode</th>
                    <th scope="col">start_time</th>
                    <th scope="col">end_time</th>
                    {/* <th scope="col"> Enquiry For</th> */}
                    <th scope="col"> extendTime</th>
                    <th scope="col"> fees_for_turor</th>
                  </tr>
                </thead>
                <tbody>
                  {attendenceData?.data?.data?.map((item, index) => {
                    return (
                      <tr style={{ cursor: "pointer" }} key={index}>
                        <td>{index + 1}</td>
                        <td>{item?.attendance_date || "-"}</td>
                        <td>{item?.class_type || "-"}</td>

                        <td>{item?.classlink}</td>
                        <td>{item?.classmode}</td>

                        <td>{item?.currentClassMode}</td>
                        <td>{item?.start_time}</td>
                        <td>{item?.end_time}</td>
                        <td>{item?.extendTime}</td>
                        <td>{item?.fees_for_turor}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </ModalBody>
          </Modal>
        </Container>
      ) : (
        <Container className=" py-7">
          <Card className="shadow mt-1">
            <CardBody className="p-1">
              <Row>
                <Col
                  md={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                  }}
                >
                  <spna>
                    <i
                      class="fa-solid fa-triangle-exclamation"
                      style={{
                        color: "red",
                        fontSize: "20px",
                        marginRight: "5px",
                      }}
                    ></i>
                  </spna>
                  No Data Found
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      )}
    </>
  );
};

export default View;
